(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[851],{

/***/ 6344:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-restaurant",
      function () {
        return __webpack_require__(8930);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-banner-bg.dc0c0f4f.jpeg","height":575,"width":1400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAADAQEBAAAAAAAAAAAAAAAAARECEiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AJfrT4t9SUAAMLX/2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6180);
/* harmony import */ var _public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1292);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4493);





function PageTitle(param) {
    var topComponent = param.topComponent, title = param.title, description = param.description, className = param.className;
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__/* .useAccessibilitySettings */ .C)().useHighContrast;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "", className),
        style: {
            backgroundImage: useHighContrast ? "unset" : "url(".concat(_public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, ")"),
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center top",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col items-center",
            children: [
                topComponent,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-4xl font-medium text-center", useHighContrast ? "text-inherit" : "text-white", description ? "mb-8" : null, topComponent ? "mt-4" : null),
                    children: title
                }),
                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-xl font-light text-center max-w-[760px]", useHighContrast ? "text-inherit" : "text-white"),
                    children: description
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_SEO; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./config/site.config.ts
var siteConfig = Object.freeze({
    title: "GoodFoodTalks",
    description: "GoodFoodTalks",
    twitterCreator: "@GoodFoodTalks"
});

;// CONCATENATED MODULE: ./components/utils/SEO.tsx



function SEO(param) {
    var pageTitle = param.title, description = param.description, socialImageSrc = param.socialImageSrc;
    var siteTitle = siteConfig.title, siteDescription = siteConfig.description, twitterCreator = siteConfig.twitterCreator;
    var title = "".concat(pageTitle, " | ").concat(siteTitle);
    var metaDescription = description !== null && description !== void 0 ? description : siteDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:creator",
                content: twitterCreator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: metaDescription
            }),
            socialImageSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: socialImageSrc
            }) : null
        ]
    });
}
/* harmony default export */ var utils_SEO = (SEO);


/***/ }),

/***/ 8930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3990);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6180);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4493);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1284);
/* harmony import */ var _components_sections_PageTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2555);
/* harmony import */ var _components_utils_SEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3618);









var RequestRestaurant = function() {
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_2__/* .useAccessibilitySettings */ .C)().useHighContrast;
    var mailtoLinkRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(""), 2), restaurantName = ref[0], setRestaurantName = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(""), 2), restaurantTown = ref1[0], setRestaurantTown = ref1[1];
    var handleFormSubmit = function(e) {
        var ref;
        e.preventDefault();
        (ref = mailtoLinkRef.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_utils_SEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: "Request Restaurant",
                description: "Request Restaurant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_PageTitle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                topComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_7__/* .ImSpoonKnife */ .VcR, {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("h-20 w-20", useHighContrast ? "text-black" : "text-primary-600"),
                    "aria-hidden": "true"
                }),
                title: "Request a restaurant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("py-10 lg:py-14", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#fbfbee]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-2 gap-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "p-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "text-2xl lg:text-3xl",
                                        children: [
                                            " ",
                                            "Help us to grow the GoodFoodTalks network"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-light mt-4 text-lg",
                                        children: "Don’t see the restaurant you are looking for on the GoodFoodTalks site? Complete the form below and we will let them know that there is demand for them to sign up."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                        onSubmit: handleFormSubmit,
                                        className: "space-y-6 mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "block",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "mb-1 font-medium",
                                                        children: "Restaurant name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "text",
                                                        id: "restaurant-name",
                                                        name: "restaurant-name",
                                                        placeholder: "Type restaurant name",
                                                        "aria-label": "Restaurant name",
                                                        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("rounded px-6 h-[50px] w-full", useHighContrast ? "bg-contrast-yellow text-black border border-black placeholder:text-black" : "border border-gray-300"),
                                                        value: restaurantName,
                                                        onChange: function(e) {
                                                            return setRestaurantName(e.target.value);
                                                        },
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "block",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "mb-1 font-medium",
                                                        children: "Restaurant town/city"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "text",
                                                        id: "restaurant-town",
                                                        name: "restaurant-town",
                                                        placeholder: "Type restaurant town/city",
                                                        "aria-label": "Restaurant town/city",
                                                        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("rounded px-6 h-[50px] w-full", useHighContrast ? "bg-contrast-yellow text-black border border-black placeholder:text-black" : "border border-gray-300"),
                                                        value: restaurantTown,
                                                        onChange: function(e) {
                                                            return setRestaurantTown(e.target.value);
                                                        },
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "sm:flex",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        type: "submit",
                                                        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("btn btn-xl", useHighContrast ? "btn-contrast-yellow" : "btn-primary"),
                                                        children: "Request restaurant"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        ref: mailtoLinkRef,
                                                        href: "mailto:matt@goodfoodtalks.com?subject=Restaurant Request - ".concat(restaurantName, " (").concat(restaurantTown, ")"),
                                                        className: "hidden",
                                                        children: "Request restaurant"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-sm italic mt-14 opacity-80",
                                        children: [
                                            "* Sending the form requires that you have a default mail application set on your device. If submitting the form does not work for you for this reason, please submit an email manually regarding your request to",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: "matt@goodfoodtalks.com"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row-start-1 lg:row-start-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("p-6", useHighContrast ? "bg-inherit" : "bg-[#f6f4df]"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-2xl lg:text-3xl",
                                            children: "Vote for popular restaurants"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "font-light mt-4 text-lg",
                                            children: "We hear there is a demand for some of the restaurants below. Place your vote against one of the below and let the restaurants know that there is a demand for them to sign up!"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RequestRestaurant);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,609,314,284,774,888,179], function() { return __webpack_exec__(6344); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);